import {
  DEFAULT_DATAS_PAGE,
  ORM_COOKIE_NAME,
  SUFFIX_ORM_LOGIN_EVENT,
  TRAFFIC_SOURCE_LOCAL_STORAGE_KEY,
  TRAFFIC_SOURCE_COOKIE_NAME,
  EMPTY_VAL,
  PARTNERS_ID_LIST,
  GACID_COOKIE_NAME,
  GACID_COOKIE_DOMAIN,
  GACID_OUTSIDE_CLIENT,
  logger,
} from '../constants';
import Cookies from 'js-cookie';
import * as TagManagerUtils from '../tag-manager-utils';
import {
  getCurrentDomain,
  getLang
} from '../../context-utils';
import {GTMloader} from '../loader';

window.dataLayer = window.dataLayer || [];

export function pushData(obj, callback) {
  const gtmId = TagManagerUtils.getGTMId();
  const eventCallback = (containerID, containerOpts, isFromGTM = true) => {
    // check if is the callback of the main container
    if (containerID == gtmId) {
      // eslint-disable-next-line no-console
      logger('## Tagmanager - pushData - processing eventCallback for container', containerID, containerOpts, isFromGTM);
      const ormCookieValue = Cookies.get(ORM_COOKIE_NAME);
      if (ormCookieValue && ormCookieValue.endsWith(SUFFIX_ORM_LOGIN_EVENT)) {
        // eslint-disable-next-line no-console
        logger(`## TagManager - Found cookie ${ORM_COOKIE_NAME} with suffix "${SUFFIX_ORM_LOGIN_EVENT}"`);
        const { datasList, isRememberMe } = _extractLoginEventDatasFrom(ormCookieValue);
        datasList.forEach((d) => {
          _pushToDataLayer(d);
        });
        // update cookie orm - remove suffix
        const newOrmCookieValue = ormCookieValue.substring(0, ormCookieValue.indexOf(SUFFIX_ORM_LOGIN_EVENT));
        const cookieOpts = {
          domain: '.' + getCurrentDomain().rootHostname,
          path: '/'
        };
        if (isRememberMe) {
          cookieOpts.expires = 365;
        }
        Cookies.set(ORM_COOKIE_NAME, newOrmCookieValue, cookieOpts);
      }
      //
      if (callback && typeof callback == 'function') {
        callback();
      }
    }
  };
  const datasSystem = _getDatasSystem();
  const datasTraffic = _getDatasTrafficSource();
  const datas = Object.assign({}, DEFAULT_DATAS_PAGE, datasSystem, datasTraffic, obj, {
    eventCallback: eventCallback,
    eventTimeout: 2000
  });

  GTMloader.isGTMReady().then(() => {
    _pushToDataLayer(datas);
  }).catch(()=> {
    eventCallback(gtmId, null, false);
  });
}

// this function is a _trackEvent and _trackCheckout dependency
export function tagsPushDataCustom(customDatas, callback) {
  const isCallback = callback != null && typeof callback == 'function';
  const gtmId = TagManagerUtils.getGTMId();

  let datas = customDatas;
  let eventCallback;
  if (isCallback) {
    // add eventcallback to datas to push
    eventCallback = (containerID, containerOpts, isFromGTM = true) => {
      if (containerID == gtmId && callback && typeof callback == 'function') {
        // eslint-disable-next-line no-console
        logger('## Tagmanager - pushDataCustom - process eventCallback for container', containerID, containerOpts, isFromGTM);
        callback(customDatas);
      }
    };
    datas = Object.assign({}, customDatas, {
      eventCallback: eventCallback,
      eventTimeout: 2000
    });
  }

  GTMloader.isGTMReady().then(() => {
    if (typeof dataLayer.find(elt => elt.event_data) !== 'undefined' && datas?.event === 'GA4event' && typeof datas?.event_data !== 'undefined') {
      _pushToDataLayer({event_data: null});
    }
    _pushToDataLayer(datas);
  }).catch(() => {
    // process only if callback exist
    isCallback && eventCallback(gtmId, null, false);
  });

  return customDatas;
}

export function _pushToDataLayer(datas) {
  if (datas && typeof(datas) == 'object' && Object.getOwnPropertyNames(datas).length != 0) {
    // eslint-disable-next-line no-console
    logger('## TagManager - push to dataLayer', datas);
    window.dataLayer.push(datas);
  } else {
    // eslint-disable-next-line no-console
    logger('## TagManager - datas not pushed to dataLayer', datas);
  }
}

function _extractLoginEventDatasFrom(ormVal) {
  const result = {
    datasList: [],
    isRememberMe: false
  };
  logger(ormVal);
  if (ormVal && ormVal.split('_').length > 5) {
    const values = ormVal.split('_');
    const isRememberMe = values[1] === 'TRUE';
    const authType = values[3];
    const authSocial = values[4];
    const isLeah = values[5] === 'TRUE';
    const contextOrigin = values[6] && values[6] !== 'LOGIN' ? values[6] : 'other';
    switch (authType) {
      case 'AUTHENTICATION':
        result.datasList.push({
          event: 'GAevent',
          eventCategory: 'authentication',
          eventAction: 'sign in - click on cta',
          eventLabel: 'connect'
        });
        // GA4
        result.datasList.push({
          event: 'GA4event',
          eventName: 'authentification_interact',
          event_data: {
            pagename : window?.dataLayer.find(el => el.dynamic_datas_ready && el.pagename)?.pagename,
            form_action : authSocial === 'STANDARD' ? 'log in':`log in ${authSocial}` ,
            connexion_context: contextOrigin
          }
        });
        
        if (isRememberMe) {
          result.datasList.push({
            event: 'GAevent',
            eventCategory: 'authentication',
            eventAction: 'sign in - click on cta',
            eventLabel: 'stay connected'
          });
          result.isRememberMe = true;
          // GA4
          result.datasList.push({
            event: 'GA4event',
            eventName: 'authentification_interact',
            event_data: {
              pagename : window?.dataLayer.find(el => el.dynamic_datas_ready && el.pagename)?.pagename,
              form_action :'stay connected',
              connexion_context: contextOrigin
            }
          }); 
        }
        break;
      case 'REGISTRATION':
        result.datasList.push({
          event: 'GAevent',
          eventCategory: 'authentication',
          eventAction: 'sign up - click on cta',
          eventLabel: (isLeah) ? 'sign up - lcah' : 'sign up'
        });
        result.datasList.push({
          event: 'GA4event',
          eventName: 'sign_up',
          event_data: {
            pagename : window?.dataLayer.find(el => el.dynamic_datas_ready && el.pagename)?.pagename,
            connexion_context : contextOrigin
          }
        });
        break;
      default:
        result.datasList.push({
          event: 'GAevent',
          eventCategory: 'authentication',
          eventAction: 'error',
          eventLabel: 'error - invalid auth type'
        });
        // eslint-disable-next-line no-console
        console.warn('## TagManager - ORM cookie - invalid authType', authType);
        break;
    }
  } else {
    result.datasList.push({
      event: 'GAevent',
      eventCategory: 'authentication',
      eventAction: 'error',
      eventLabel: 'error - orm wrong format'
    });
    // eslint-disable-next-line no-console
    console.warn('## TagManager - ORM cookie - wrong format', ormVal);
  }

  return result;
}

export function _getDatasSystem() {
  const datas = {};
  datas.event = 'push_dynamic_datas';
  datas.dynamic_datas_ready = true;
  datas.language = getLang();
  datas.countrymarket = TagManagerUtils.getCountryMarket();
  datas.devicetype = TagManagerUtils.getDeviceType();
  datas.currencycode = 'EUR';
  datas.userId = TagManagerUtils.getUserId();
  datas.brandcontext = TagManagerUtils.getBrandContext();
  datas.env = datas.env || TagManagerUtils.getEnv();
  return datas;
}

export function _getDatasTrafficSource() {
  let datas = {};
  datas.gacid = Cookies.get(GACID_OUTSIDE_CLIENT) || Cookies.get(GACID_COOKIE_NAME) || EMPTY_VAL;
  datas.uamerchantid = EMPTY_VAL;
  datas.uasourceid = EMPTY_VAL;
  datas.tarsmerchantid = EMPTY_VAL;
  datas.tarssourceid = EMPTY_VAL;

  if (datas.gacid && !Cookies.get(GACID_OUTSIDE_CLIENT)) {
    Cookies.set(GACID_OUTSIDE_CLIENT, datas.gacid, { domain: GACID_COOKIE_DOMAIN })
    TagManagerUtils.deleteCookie(GACID_COOKIE_NAME);
  }

  const cookieTrafficSourceValue = Cookies.get(TRAFFIC_SOURCE_COOKIE_NAME);
  if (cookieTrafficSourceValue && cookieTrafficSourceValue.length >= 2) {
    // decode from base64 the traffic source cookie and convert it to object
    const decodedCookieValue = decodeURIComponent(escape(atob(cookieTrafficSourceValue)));
    const trafficSource = JSON.parse(decodedCookieValue);

    // Check if current values exist
    if (trafficSource.currentmerchantid == undefined && trafficSource.currentsourceid == undefined) {
      // Sourceid and merchantid are empty
      // ua* values are from referrer
      const source = TagManagerUtils.getSourceFromReferrer();
      datas = TagManagerUtils.saveToDatas(datas, {
        uamerchantid: source,
        uasourceid: source
      });
    } else {
      // Sourceid/merchantid and ua* are equals
      // Get values from cookie
      datas = TagManagerUtils.saveToDatas(datas, {
        uamerchantid: trafficSource.currentmerchantid,
        uasourceid: trafficSource.currentsourceid
      });
    }

    // Check if retained values exist
    if (trafficSource.retainedmerchantid == undefined && trafficSource.retainedsourceid == undefined) {
      // Get tars* value from referrer
      const source = TagManagerUtils.getSourceFromReferrer();
      datas.tarsmerchantid = source;
      datas.tarssourceid = source;
    } else {
      // Get tars* value from cookie
      datas.tarsmerchantid = trafficSource.retainedmerchantid;
      datas.tarssourceid = trafficSource.retainedsourceid;
    }
    // Save tars* values to local storage
    try {
      localStorage.setItem(TRAFFIC_SOURCE_LOCAL_STORAGE_KEY, JSON.stringify({
        tarsmerchantid: datas.tarsmerchantid,
        tarssourceid: datas.tarssourceid
      }));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('## TagManager - Error while localStorage.setItem for key %s', TRAFFIC_SOURCE_LOCAL_STORAGE_KEY, error);
    }

  } else {
    // eslint-disable-next-line no-console
    logger('## Tagmanager - cookie ' + TRAFFIC_SOURCE_COOKIE_NAME + ' not found');

    // Sourceid and merchantid are empty
    // ua* values are from referrer
    const source = TagManagerUtils.getSourceFromReferrer();
    datas = TagManagerUtils.saveToDatas(datas, {
      uamerchantid: source,
      uasourceid: source
    });
    // If local storage exist, get tars* value from local storage
    let trafficSourceLocalStorage = JSON.parse(localStorage.getItem(TRAFFIC_SOURCE_LOCAL_STORAGE_KEY));
    if (trafficSourceLocalStorage) {
      datas.tarsmerchantid = trafficSourceLocalStorage.tarsmerchantid;
      datas.tarssourceid = trafficSourceLocalStorage.tarssourceid;
    } else {
      // Tars* value are same as ua*
      datas.tarsmerchantid = datas.uamerchantid;
      datas.tarssourceid = datas.uasourceid;
    }
  }

  // Add partner IDs to datas
  datas = Object.assign({}, datas, TagManagerUtils.getPartnerIdValueFromCookie(PARTNERS_ID_LIST));
  return datas;
}
